import { useState } from "react";
import { BasicPage } from "../../../theme/Component/BasicPage";
import type { DocumentFolderItem } from "./DocumentFileManager.types";
import { DocumentFileManagerContent } from "./components/DocumentFileManagerContent";
import { DocumentRecordsView } from "./components/DocumentRecordsView";
import "./DocumentFileManager.css";

const DocumentFileManagerView = () => {
    const [selectedFolder, setSelectedFolder] = useState<DocumentFolderItem | null>(null);

    return (
        <>
            {selectedFolder === null ?
                <div className="document-file-manager document-file-manager--records">
                    <div className="document-file-manager__records">
                        <DocumentRecordsView onSelectFolder={setSelectedFolder} />
                    </div>
                </div>
                :
                <div className="document-file-manager document-file-manager--detail">
                    <main className="document-file-manager__content">
                        <DocumentFileManagerContent
                            fileRecordId={selectedFolder.id}
                            fileRecordName={selectedFolder.name}
                            onBackToRecords={() => setSelectedFolder(null)}
                        />
                    </main>
                </div>
            }
        </>
    );
};

export const DocumentFileManager = () => {
    return (
        <BasicPage titulo="Gestor documental">
            <DocumentFileManagerView />
        </BasicPage>
    );
};
